module.exports = __webpack_public_path__ + "img/vertical_3_2_1.fecce362.png";